import { useFilter, useFilterDispatch } from '../../../contexts/filter-context';
import { Button } from '../../widgets/button/button';
import { Modal } from '../../widgets/modal/modal';
import './sort-modal.css';
import { ReactComponent as ArrowUp } from '../../../assets/arrow-up.svg';
import { ReactComponent as ArrowDown } from '../../../assets/arrow-down.svg';
import { useState } from 'react';
import { useModal } from '../../../contexts/modal-context';

const SortItem = ({ id, label, isFirst, isLast, onUp, onDown }) => {
  return (
    <div className="sort-item">
      <div className="sort-item-label">{label}</div>
      <Button icon={<ArrowUp />} size="normal" disabled={isFirst} onClick={onUp}></Button>
      <Button icon={<ArrowDown />} size="normal" disabled={isLast} onClick={onDown}></Button>
    </div>
  );
};

export const SortModal = () => {
  const [items, setItems] = useState([
    { id: 'charity_navigator_rating', label: 'Charity Navigator rating', direction: 'desc' },
    { id: 'revenue', label: 'Revenue', direction: 'desc' },
    { id: 'name', label: 'Organization name', direction: 'asc' },
  ]);
  const { isOpen, setOpen } = useModal();
  const dispatchFilter = useFilterDispatch();
  const filter = useFilter();

  const move = (array, fromIndex, toIndex) => {
    array.splice(toIndex, 0, array.splice(fromIndex, 1)[0]);
  };

  const handleUp = (item) => {
    const newItems = [...items];
    move(newItems, items.indexOf(item), items.indexOf(item) - 1);
    setItems(newItems);
  };
  const handleDown = (item) => {
    const newItems = [...items];
    move(newItems, items.indexOf(item), items.indexOf(item) + 1);
    setItems(newItems);
  };
  const commitChanges = () => {
    dispatchFilter({ type: 'sortspec-set', sortSpec: items });
    setOpen('sort-modal', false);
  };
  return (
    <div className="sort-modal">
      <Modal
        id={'sort-modal'}
        headerLabel="Sort Options"
        footer={
          <div className="sort-modal-button-container">
            <Button size="normal" onClick={() => setOpen('sort-modal', false)}>
              Cancel
            </Button>
            <Button color="highlight" size="normal" onClick={() => commitChanges()}>
              Confirm
            </Button>
          </div>
        }
      >
        <div className="sort-item-container">
          {items.map((item, index) => (
            <SortItem
              key={item.id}
              id={item.id}
              label={item.label}
              isFirst={index === 0}
              isLast={index === items.length - 1}
              onUp={() => handleUp(item)}
              onDown={() => handleDown(item)}
            />
          ))}
        </div>
      </Modal>
    </div>
  );
};
